import React, { useState } from 'react';
import { Container, Paper, Box, Tabs, Tab, Typography } from '@mui/material';
import ProductsManagement from './ProductsManagement';
import OrdersManagement from './OrdersManagement';


function AdminDashboard() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Products" />
            <Tab label="Orders" />
          </Tabs>
        </Box>

        {activeTab === 0 && <ProductsManagement />}
        {activeTab === 1 && <OrdersManagement />}
      </Paper>
    </Container>
  );
}

export default AdminDashboard;